import React from "react";
import RichTextEditor from "@/components/ui/RichTextEditor";

interface ContentEditorProps {
  initialContent?: string;
  onChange?: (html: string) => void;
}

const ContentEditor: React.FC<ContentEditorProps> = ({ 
  initialContent = "", 
  onChange 
}) => {
  return (
    <RichTextEditor
      initialContent={initialContent}
      onChange={onChange}
      placeholder="Enter content here..."
      height="350px"
    />
  );
};

export default ContentEditor; 